export const FALLBACK_APPRECIATION_PERCENT = 2.5
export const STEADY_APPRECIATION_PERCENT = 3.25
export const FAST_APPRECIATION_PERCENT = 4
